<template>
  <div  class="login_style"></div>
</template>

<script>
  export default {
    name: 'TransferLogin',
    data () {
      return {
        username: '',
        companyId: '',
        password: '',
        createCode: '',
        loading:false,
        player:null,
        footerStyle:{marginTop:''},
        videoHeight:{height:''},
        templateStyle:{marginTop:''},
        InputStyle:{marginTop:''},
        rememberPassWord: false,
        loginCount:false,
        options: {autoplay: true, muted: true, controls: false}
      }
  },
  methods: {
    login: function (companyCode,companyId,token) {
      let that = this;
      let param={
        companyCode:companyCode,
        companyId:companyId,
        token:token,
        journalType:"null",
        menuId:"null"
      };
     let customerType=[];
      this.$http.post("login/doLogin.json",param).then(function (res) {
        let result = res.data.flag;
        if (result ==  "000") {
          that.$Message.info("请输入验证码");
          that.getValidateCode();
          return false
        }
        if (result !=  "666") {
          that.$Message.error(res.data.msg);
          return false
        }
        if(res.data.obj.customerType){
          customerType=res.data.obj.customerType;
        }
        let list=res.data.obj.menuList;
        let agentInfo=res.data.obj.agentInfo;
        let menuList={};
        for (let i=0;i<list.length;i++){
          menuList[list[i]]=true;
        }
        document.onkeydown = undefined;
        that.companyCode=agentInfo.companyCode;
        that.initLoginArgument(res.data.obj);
        localStorage.setItem("signinStatus","0");
        localStorage.setItem('roleList', JSON.stringify(menuList));
        localStorage.setItem('companyId', that.companyCode);
        localStorage.setItem('token', res.data.obj.token);
        localStorage.setItem('companyLogo', res.data.obj.configInfo.companyLogo);
        localStorage.setItem('agentInfo',  JSON.stringify(res.data.obj.agentInfo));
        let configItem = res.data.obj.configInfo;
        configItem.isHiddenService = configItem.isHiddenService?configItem.isHiddenService:'0';
        configItem.screenShow = configItem.screenShow?configItem.screenShow:'0';
        localStorage.setItem('configInfo', JSON.stringify(configItem));
        localStorage.setItem('sendMessageFlag',  res.data.obj.sendMessageFlag);
        localStorage.setItem('phoneType', res.data.obj.agentInfo.phoneType);
        localStorage.setItem('customerType', JSON.stringify(customerType));
        localStorage.setItem("pstnNumber",res.data.obj.agentInfo.pstnNumber);
        localStorage.setItem("phoneType",res.data.obj.agentInfo.phoneType);
        localStorage.setItem("outPhonePick",res.data.obj.agentInfo.externalAnswer);
        localStorage.setItem("hangupAgentStatus",res.data.obj.agentInfo.agentStatus);
        localStorage.setItem("thirdPopupAddress",res.data.obj.thirdPopupAddress);
        localStorage.setItem("autoSignIn", res.data.obj.agentInfo.autoSignIn);
        localStorage.setItem("supportAI",res.data.obj.supportAI);
        localStorage.setItem("companyType",res.data.obj.companyType);//存储企业类型
        localStorage.setItem("registeredCertificate",res.data.obj.registeredCertificate);//注册证书
         localStorage.setItem("externalPhoneAutoAnswer",res.data.obj.configInfo.externalPhoneAutoAnswer);//是否外置话机呼出自动接听
          //是否企业支持AI助手座席
        localStorage.setItem("supportAiAssistant",res.data.obj.supportAiAssistant);
        //是否企业支持视频座席
        localStorage.setItem("sysSupportVideo",res.data.obj.sysSupportVideo);
        //是否企业支持在线客服
        localStorage.setItem("sysSupportChat",res.data.obj.sysSupportChat);
        localStorage.setItem("batchDownloadRecordingFlag",res.data.obj.batchDownloadRecordingFlag);//录音批量下载
        localStorage.setItem("quickApply",JSON.stringify(res.data.obj.quickApply));//快速应用
        localStorage.setItem("valueTime"+param.companyCode+"_"+res.data.obj.agentInfo.agentNumber,"");//用于验证sso重复登录的时间戳.后台切换的为空不进行验证
        //企业是否支持工单
        localStorage.setItem("sysSupportWorkOrder",res.data.obj.sysSupportWorkOrder);
        //企业是否开启工单类型且有数据
        localStorage.setItem("isOpenOrderType",res.data.obj.isOpenOrderType);

        that.$http.defaults.headers.Authorization="Bearer "+res.data.obj.token;
        that.$http.defaults.headers.companyCode=companyCode;
        localStorage.setItem('loginSign','0');
        that.$router.push({path: '/index'});
        localStorage.setItem('loginName', agentInfo.agentNumber);

        that.$http.post("login/loginConfig.json",param).then(function (res) {
      let result=res.data.flag;
      if(result!="666"){
        that.$Modal.info({
          title:'提示',
          content:res.data.msg
        });
        return false;
      }
      that.initArgument(res.data.obj);
    });

        that.registerPhone();
      })
    },
  // 保存cookie
    setCookie: function (name, value) {
      let exp = new Date();
      exp.setTime(exp.getTime() + 30*24*60*60*1000*12);
      document.cookie = name + "="+ escape (value) + ";expires=" + exp.toGMTString();
    },
    getUrlKey: function (name) {
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
    },
    init:function () {
      let param={
        journalType:"null",
        menuId:"null",
      };
      let that = this;
      this.$http.post("login/loginConfig.json",param).then(function (res) {
        let result=res.data.flag;
        if(result!="666"){
          that.$Modal.info({
            title:'提示',
            content:res.data.msg
          });
          return false;
        }
        that.initArgument(res.data.obj);
        let companyCode = that.$route.query.companyCode;
        let companyid = that.$route.query.companyId;
        let token = that.$route.query.token;
        that.login(companyCode,companyid,token);
      });
    }
  },
  mounted(){
    this.init();
    let cacheCustomerList={};
    localStorage.setItem("cacheCustomerList",JSON.stringify(cacheCustomerList));
  }
}
</script>

<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/components/login/TransferLogin.vue